export const soldProductsV2 = {
	tabTitle: "Products Sold",
	header: {
		title: "Products Sold",
		subtitle: "Track products sold and view your sales in detail.",
		exportButton: "Export",
		exportLoading: "Exporting...",
		exportNotification:
			"the report will be generated and once ready it will be sent to your e-mail ({{email}})",
	},
	inlineFilters: {
		filterByProduct: "Filter by product",
		noProductFound: "No product found",
		filterByCategory: "Filter by product category",
		noCategoryFound: "No category found",
		filtersButton: "Filters",
		groupByProduct: "Grouped by Product",
		groupByBar: "Grouped by Bar",
	},
	filterModal: {
		title: "Filters",
		filterOptionsLabel: "Filter options",
		filteredBy: "Filtered by",
		clearSelection: "Clear selection",
		cancel: "Cancel",
		clearFilters: "Clear filters",
		apply: "Apply",
		nav: {
			dateOrPeriod: "Date or period",
			product: "Product",
			barsAndSectors: "Bars and sectors",
			operation: "Operation",
			transactions: "Transactions",
		},
		period: {
			today: "Today",
			yesterday: "Yesterday",
			last30Days: "Last 30 days",
			customPeriod: "Custom period",
		},
		periodLabels: {
			today: "today",
			yesterday: "yesterday",
			last_30_days: "last 30 days",
			custom: "custom period",
		},
		productSection: {
			productLabel: "Product",
			productStatusLabel: "Product status",
			productTypeLabel: "Product type",
			categoryLabel: "Category",
			filterByProduct: "Filter by product",
			filterByType: "Filter by type",
			filterByCategory: "Filter by category",
			noProductFound: "No product found",
			noTypeFound: "No type found",
			noCategoryFound: "No category found",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
			unavailable: "Unavailable",
		},
		barsAndSectorsSection: {
			barLabel: "Bar",
			sectorLabel: "Sector",
			filterByBar: "Filter by bar",
			filterBySector: "Filter by sector",
			noBarFound: "No bar found",
			noSectorFound: "No sector found",
		},
		operationSection: {
			operationTypeLabel: "Operation type",
		},
		operationTypes: {
			Table: "Table operation",
			ZigTag: "Cashless operation",
		},
		transactionsSection: {
			transactionTypeLabel: "Transaction type",
			filterByTransaction: "Filter by transaction",
			noTypeFound: "No type found",
		},
		sources: {
			balcony: "Counter",
			cashless: "Cashless",
			dash: "Dashboard",
			delivery: "Delivery",
			ficha: "Ticket",
			grabngo: "Grab n Go",
			onlineBill: "Online Bill",
			zigQrcode: "Zig QR Code",
			onlineFicha: "Online Ticket",
			table: "Table",
			hce: "Digital Card",
		},
		activeFilterLabels: {
			period: "PERIOD",
			status: "STATUS",
			operation: "OPERATION",
			product: "PRODUCT",
			category: "CATEGORY",
			bar: "BAR",
			sector: "SECTOR",
			transaction: "TRANSACTION",
		},
	},
	table: {
		sku: "SKU",
		name: "Name",
		status: "Status",
		statusLabels: {
			active: "Active",
			inactive: "Inactive",
			unavailable: "Unavailable",
		},
		unitQty: "Unit Qty",
		unitValue: "Unit Value",
		subtotal: "SUBTOTAL",
		discounts: "Discounts",
		totalValue: "TOTAL VALUE",
		subtotalTooltip: "Total value without discounts applied.",
		totalValueTooltip: "Total value with discounts applied.",
		mountable: "(mountable)",
		devolution: "Devolution",
		total: "Total",
		values: "{{count}} values",
		noBar: "No bar",
		variationUnitQty: "Unit Qty",
		variationUnitValue: "Unit Value",
		variationSubtotal: "Subtotal",
		variationDiscounts: "Discounts",
		variationTotalValue: "Total Value",
	},
	mountableModal: {
		name: "Name",
		section: "Section",
		quantity: "Quantity",
	},
};
